/**
 * Routes for Enterprise Module
 */
export const paths = {
    root: '/enterpriseManagement',
    enterpriseList: '/enterpriseManagement/enterprises',
    enterpriseUsers: '/enterpriseManagement/:enterpriseId/users',
    createEnterprise: '/enterpriseManagement/createEnterprise',
    editEnterprise: `/enterpriseManagement/enterprises/:enterpriseId/edit`
};

export const navigation = {
    editEnterprise: enterpriseId => `/enterpriseManagement/enterprises/${enterpriseId}/edit`,
    enterpriseUsers: enterpriseId => `/enterpriseManagement/${enterpriseId}/users`
};
